import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Ebooks',
    href: '#ebooks'
  }, {
    name: 'Temas',
    href: '#temas'
  }, {
    name: 'Sobre la marca',
    href: '#nosotros'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-blanco/80 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-145">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-146">
        <a href="#inicio" className="font-medium tracking-wide text-texto text-[14px] font-[Cinzel,_serif]" data-id="element-147">
          habitando mi cuerpo
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-148">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-sans text-sm font-medium text-textoSuave hover:text-texto transition-colors" data-id="element-149">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-texto p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-150">
          {mobileMenuOpen ? <XIcon size={24} data-id="element-151" /> : <MenuIcon size={24} data-id="element-152" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-153">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-crema border-b border-beige overflow-hidden" data-id="element-154">
            <div className="px-6 py-8 flex flex-col gap-6" data-id="element-155">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="font-serif text-2xl text-texto" data-id="element-156">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}